var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.684 6.895L3.211 8.368a3.126 3.126 0 000 4.421v0a3.126 3.126 0 004.42 0l1.474-1.473M6.895 4.685L8.368 3.21a3.126 3.126 0 014.421 0v0a3.126 3.126 0 010 4.42l-1.473 1.475M10.01 5.99l-4.168 4.168",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/external_link.a61a9b7c.svg";
export { SvgExternalLink as ReactComponent };